import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';
import { FC, useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { cx } from '@linaria/core';
interface FastMarkdownProps {
  markdownText: string;
  className?: string;
}
export const FastMarkdown: FC<FastMarkdownProps> = ({
  markdownText,
  className
}) => {
  const [html, setHtml] = useState<string>('');
  useEffect(() => {
    setHtml(DOMPurify.sanitize((marked.parse(markdownText) as string)));
  }, [markdownText]);
  // Necessary to use `dangerouslySetInnerHTML` to render the HTML generated by marked
  // and sanitized by DOMPurify, as React does not support rendering raw HTML strings directly
  // This is safe because we sanitize the input to prevent XSS attacks
  // eslint-disable-next-line react/no-danger
  return <div className={cx('wmde-markdown', className)} data-color-mode="light" dangerouslySetInnerHTML={{
    __html: html
  }} />;
};